import type { Prefab } from "../prefab";
import { buildPrefab, buildPrefabWithOverrides } from "./prefabBuilder";
import {
	lTunnelData,
	lTunnel2Data,
	lavaCrossData,
	fireTowerChasmData,
	chasmLootData,
	caveArrivalData,
	sculptures3Data,
} from "./cavePrefabData";

export function getCaveArrival(levelOrigin: number): Prefab {
	return buildPrefabWithOverrides(caveArrivalData, {
		U: { class: "Upstairs", props: { destination: levelOrigin } },
	});
}

export function getLTunnel(): Prefab {
	return buildPrefab(lTunnelData);
}

export function getLTunnel2(): Prefab {
	return buildPrefab(lTunnel2Data);
}

export function getLavaCross(): Prefab {
	return buildPrefab(lavaCrossData);
}

export function getFireTowerChasm(): Prefab {
	return buildPrefab(fireTowerChasmData);
}

export function getChasmLoot(): Prefab {
	return buildPrefab(chasmLootData);
}

export function getSculptures3(): Prefab {
	return buildPrefab(sculptures3Data);
}
